import React from "react";
import classes from "./GridCardContainer.module.css";

export default function GridCardContainer(props) {
  return (
    <div style={props.style} className={classes.gridContainer}>
      {props.children}
    </div>
  );
}
